<template>
  <div>
    <el-tabs v-model="activeTabName">
      <el-tab-pane name="渠道管理" label="渠道管理">
        <ChannelConfigPage v-if="activeTabName == '渠道管理'" />
      </el-tab-pane>
      <el-tab-pane name="合服管理" label="合服管理">
        <MergeZonesPage v-if="activeTabName == '合服管理'" />
      </el-tab-pane>
      <el-tab-pane name="系统设置" label="系统设置">
        <SystemConfigPage v-if="activeTabName == '系统设置'" />
      </el-tab-pane>
      <el-tab-pane name="短ID生成器" label="短ID生成器">
        <ShortIdGeneratorPage v-if="activeTabName == '短ID生成器'" />
      </el-tab-pane>
      <el-tab-pane name="可玩日管理" label="可玩日管理">
        <PlayableDayConfigPage v-if="activeTabName == '可玩日管理'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SystemConfigPage from "./SystemConfigPage";
import ChannelConfigPage from "./ChannelConfigPage";
import MergeZonesPage from "./MergeZonesPage";
import ShortIdGeneratorPage from "./ShortIdGeneratorPage";
import PlayableDayConfigPage from "./PlayableDayConfigPage";

export default {
  data() {
    return {
      activeTabName: "渠道管理",
    };
  },

  components: {
    SystemConfigPage,
    ChannelConfigPage,
    MergeZonesPage,
    ShortIdGeneratorPage,
    PlayableDayConfigPage,
  },
};
</script>